import { useEffect, useState } from "react";

// Fast background work should not flash a spinner or announce itself. Only
// explain a wait when it actually lasts long enough to hold up the shopper.
export default function DeferredFeedback({ active, children, fallback = null, delay = 1000 }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(false);
    if (!active) return undefined;
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [active, delay]);
  return active && visible ? children : fallback;
}
